<template>
    <Head>
        <title>Настройки Backoffice</title>
    </Head>

    <authenticated-layout>

        <template #header>
            <navigation/>
        </template>


        <div class="flex flex-col gap-8 p-8">
            <div class="flex justify-between items-center">
                <h1 class="text-2xl font-bold">Настройки Backoffice</h1>
                <div class="flex gap-2 font-bold">
                    <span>Server time (UTC):</span>
                    <span>{{ moment(serverWatch*1000).utc().format('L LTS') }}</span>
                </div>
            </div>

            <div class="p-6 bg-white rounded">
               <div class="grid grid-cols-5 border-b gap-2 p-2">
                   <strong>Name</strong>
                   <strong>Value</strong>
                   <strong class="text-center">Created</strong>
                   <strong class="text-center">Updated</strong>
                   <strong></strong>
               </div>

                <div class="grid grid-cols-5 border-b gap-2 p-2">
                    <v-input v-model="createSetting.name"/>
                    <v-input v-model="createSetting.value"/>
                    <div class="col-span-2"></div>
                    <div class="flex justify-end gap-2">
                        <v-button type="button" color="blue" @click="store">Create</v-button>
                    </div>
                </div>

                <div class="grid grid-cols-5 gap-2 p-2 items-center" v-for="setting of settings">
                    <v-input v-model="setting.name"/>
                    <v-input v-model="setting.value"/>
                    <span class="text-center">{{ moment(setting.created_at).format('L LTS') }}</span>
                    <span class="text-center">{{ moment(setting.updated_at).format('L LTS') }}</span>
                    <div class="flex justify-end gap-2">
    <!--                    <v-button type="button" color="red">delete</v-button>-->
                        <v-button type="button" color="green" @click="update(setting.id)">update</v-button>
                    </div>
                </div>

            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import {ref} from "vue";
import moment from 'moment';
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/Administration';
import VInput from '@/Components/Input';
import VButton from '@/Components/Button';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        VInput,
        VButton,
    },
    props: {
        settings: Object,
        serverTime: Number,
    },
    setup () {
        return {
            serverWatch: ref(null),
            createSetting: ref({
                name: '',
                value: '',
            })
        }
    },
    methods: {
        moment,
        store() {
            axios.post(this.route('admin.settings.store'), this.createSetting).then(() => {
                this.createSetting.name = '';
                this.createSetting.value = '';
                this.$inertia.reload({
                    preserveState: false,
                    preserveScroll: false,
                })
            })
        },
        update(id) {
            axios.put(this.route('admin.settings.update', id), this.settings[id]);
        },
    },
    mounted() {
        this.serverWatch = Number(this.serverTime);
        setInterval(() => {
            this.serverWatch++;
        }, 1000);
    }
}
</script>
